/* eslint-disable no-console */
import get from 'lodash/get';
import { siteModule, siteCommonSuffix } from '../cdn/constants';

const setDigitalData = (enabled = false) => {
    try {
        window.isServiceWorkerInstalled = enabled;
        window.digitalData.page.pageInfo.serviceWorkerInstalled = enabled ? 'yes' : 'no';
    } catch (ex) {
        // supressed error;
    }
};

/**
 * This makes use of probability to run the test on limited set of users
 * @param {Object} context
 * @returns boolean
 */
const randomAB = (context) => {
    try {
        const {
            preferences: { serviceWorkerABSet },
        } = context;

        if (serviceWorkerABSet) {
            const LSKey = 'serviceWorkerAB';
            const previousLSVal = localStorage.getItem(LSKey);
            if (previousLSVal) {
                return JSON.parse(previousLSVal.toLowerCase());
            }
            const randomResult = !!serviceWorkerABSet[
                Math.floor(Math.random() * serviceWorkerABSet.length)
            ];
            localStorage.setItem(LSKey, randomResult);
            return randomResult;
        }
    } catch (err) {
        console.log(err);
    }

    return true;
};

/**
 * Verifies if the device is eligible to support service worker
 * and caching
 */
const isDeviceEligibleForSW = async (context) => {
    try {
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        const abTest = randomAB(context);

        // safari isn't supporting device memory and quota at this time
        if (isSafari && 'serviceWorker' in navigator && abTest) {
            return true;
        }
        const { quota } = await navigator.storage.estimate();

        // service worker supported
        return (
            abTest &&
            'serviceWorker' in navigator &&
            // device memory > 2 GB
            navigator.deviceMemory > 2 &&
            // storage quota > 1024 MB, not suported by safari
            quota * 1e-6 > 1024
        );
    } catch (ex) {
        return false;
    }
};

/**
 * Forces abortion of active n/w consumed by service worker
 * during transition to a new page
 */
const abortSWActivityOnUnload = () => {
    window.addEventListener('unload', () => {
        navigator.serviceWorker &&
            navigator.serviceWorker.ready &&
            navigator.serviceWorker.ready.then((registration) => {
                registration.active.postMessage({
                    message: 'ABORT_ACTIVITY',
                });
            });
    });
};

const getSWPath = (context) => {
    const { preferences = {}, cluster } = context;
    const { version = '' } = get(preferences, 'prefetchcomponents', {});

    // ex- /static/prod3/yoda-site-components/2015.0.20/site-common/sw.js
    return `/static/${cluster}/${siteModule}/${version}/${siteCommonSuffix}/sw/sw.js`;
};

export const install = async (context) => {
    // this should be called after the load of the page
    if (await isDeviceEligibleForSW(context)) {
        setDigitalData(true);
        console.log('service worker eligible for registration');
        window.addEventListener('load', () => {
            // adds addtional timeout before the sw caching begins
            // this allows some delay after load even to allow addtional resources to load
            setTimeout(() => {
                navigator.serviceWorker.register(getSWPath(context)).then(
                    (registration) => {
                        // Registration was successful
                        registration.active &&
                            registration.active.postMessage({
                                message: 'CACHE_STATIC_NEXT_ROUTE',
                                payload: { url: document.location.href },
                            });
                    },
                    (err) => {
                        // registration failed
                        console.error('ServiceWorker registration failed: ', err);
                    }
                );
            }, 3e3);
        });
    } else {
        console.error('This device is not optimized for service worker');
    }
    abortSWActivityOnUnload();
};

/** Clears all cache */
const clearCache = async () => {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
};

export const uninstall = () => {
    setDigitalData(false);
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            registrations.forEach((registration) => registration.unregister());
        });
        clearCache();
    }
};
